<template>
    <div id="app">
        <headerMenu></headerMenu>
        <div class="app-top"></div>
        <router-view/>
        <customerFooter></customerFooter>
    </div>
</template>

<script>

import customerFooter from "@/components/customFooter.vue";
import headerMenu from "@/components/headerMenu.vue"

export default {
    name: 'App',
    components: {customerFooter, headerMenu},
    // mounted() {
    //     window.addEventListener('resize', () => {
    //         this.onRefresh()
    //     })
    // },

    // methods: {
    //     onRefresh() {
    //         this.$router.go(0)
    //     }
    // },

    // destroyed() {
    //     window.removeEventListener('resize', this.onRefresh())
    // }
}
</script>

<style lang="less">

* {
    margin: 0;
    padding: 0;
}

.app-top {
    height: 10px;
    width: 100%;
    background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue